import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["PaginationNext"], _mergeProps({
        "data-slot": "pagination-next",
        class: $setup.cn($setup.buttonVariants({ variant: 'ghost', size: $props.size }), 'gap-1 px-2.5 sm:pr-2.5', $setup.props.class)
    }, $setup.forwarded), {
        default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default", {}, () => [
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "hidden sm:block" }, "Next", -1 /* CACHED */)),
                _createVNode($setup["ChevronRightIcon"])
            ])
        ]),
        _: 3 /* FORWARDED */
    }, 16 /* FULL_PROPS */, ["class"]));
}
